import React from 'react'
import { useTranslation } from 'react-i18next';

// Icons
import LinkedinIcon from 'assets/icons/social-media/LinkedinIcon';

function OurTeam() {
  const { t } = useTranslation();

  const teams = [
    {
      image: 'https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/ae7f97b6c732dbe2194eb59ef48baa2b73b8c185fc6f36a473e584120754a7293e5abf888bfeb362d04f884056456a3a6e08d630ae56ae29fba076eebadf8e9f672f55f224b488755071a47faef8b4c718d2c7b8c5fe2a3d84fb7204a5bec4a73720a45c10e08513f05de6e8e167fdab9b5a89522136b184f1d2/rez-file-1739419760214.png',
      name: "Maria Rosaline Nindita R.",
      position: "Founder",
      linked_in_url: 'https://www.linkedin.com/in/mariaradyati'
    },
    {
      image: 'https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/a5beef918d2c08caf5770703c48d36ee27ffc96409bc8ef78a734df84bc29938b81d1f81816f249bb0ab9b7b4b74525b0190acfba7ce474a6e0a1327a1f2c7b08df77bfe1c69df478975e7d0d5d5bae7d75e56412501be116fcf77873c33625a52f5960c48ad8aa7b3b9d2000a144c6d0a116d90db6da9db1bee/rez-file-1739419776663.png',
      name: "Catharina Widjaja",
      position: "Co-Founder",
    },
    {
      image: 'https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/da5e28a476059b90d24267d7fdd02f53b602fa2cee0dfa4fb209605966b8fa025236f48e25a404524b3b21cde5cbb0cb6051257466926ba67fa799dc9044e35a89805e82cd9f2e8cbb38de7a3e32bc59b2c3b9ce8836cb6aee734b009947a731e30affc81eac2298971c644ddefc7d5ce4060aceddfac8c89818/rez-file-1739419793052.png',
      name: "Albert Agung Arditya",
      position: "Director",
      linked_in_url: 'https://www.linkedin.com/in/albert-agung-arditya'
    },
    {
      image: 'https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/f858b4486dd223d59b007aa5006c3db8a239917d3600aef32a802e03ca58155c4563f8d57b69ad1cb01e88cd79fda5d970568696e923275c156a932e91f253bd73051569f7a3e332cf9b6a5e6fc0c858b9394ceb74b9f360c7b3cae061bb0d962c01d18ee0609f88c50c551e8528fd54e6d9ef900d2596002567/rez-file-1739419811304.png',
      name: "Widyamurti Paramita",
      position: "Vice Director",
    },
    {
      image: 'https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/64f4998494293c2d2bb0673bd411dc7222bbf0ef63a5efa418cd4a777a185e3bd3fdd4b2d84737b7b9190dd3d5c92eac206153e0c8b134dab678f7c52e205b66239a1430f40d4f043b5f0bcb914adbbb60712cdfb38c3183b5c728df305525564e4e36d85990622a1b09318fc5de66c1f4dccd46e28b246740d8/rez-file-1739419825218.png',
      name: "Meilisa",
      position: "Managing Partner",
      linked_in_url: 'https://www.linkedin.com/in/meilisasanjaya'
    },
    {
      image: 'https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/2889398df4af163a7888f7313b867542f5a9ee91265e21d7da7e3aa4f813b0ffb36618f9b599d01a064f820856dc8cb1f3d8f51193a14f1d8b02df6fed9287c48e3b2e058ff433d656174de823340327640b858c15221f5f42a21d92f542b94162c7ca76428f5b6523ccbcc42bff455cb72ff5e5ddc3493d803b/rez-file-1739419957900.png',
      name: "Emilianus Irawanto",
      position: "Administrative Manager",
    },
    {
      image: 'https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/2b9244cddb5a2b5f649a21ca36d8b9edf7b38ed5a57b36abca55492be8f2619e328872a075a6fb10ade6d621e03d6fc71d9494a6a658f9d56fe2ec5fae5be360f591fa9c83d74f72b3375c59d96f67b5a1aa2e8aec62dc9c107cdb1c9bc38637bf5c1312b1c32698beef97f641245932c103d70cf32fe9b361cd/rez-file-1739419917761.png',
      name: "Hasna Hanansari",
      position: "Researcher Assistant",
      linked_in_url: 'https://www.linkedin.com/in/hasnahanansari'
    },
  ]

  return (
    <div>
      <section>
        <div className='relative'>
          <img src="https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/c35151b111caa8fde6e9fa8fe5612090c1580fa0afadd70743b3f4dcee86083e115c9f98e84e493289e2ce3e818580c4e58c3897c653d02b77afdaaddf656d8c1f491448613b7a2db205d6e5c65e15808498e53a0b7e177d6b5ae439ece16ba0b3db083869bb19e373bf3f0bc68303fd422e83f85903be5ba198/rez-file-1739771406254.jpg" alt="main" className='object-cover object-center w-full max-h-40 sm:max-h-80' />
          <div className='absolute top-0 bottom-0 left-0 right-0 text-white bg-app-orange/10'>
            <div className='flex flex-col items-center justify-center h-full gap-4 app-main-container sm:gap-8'>
              <p className='text-xl/[2rem] sm:text-3xl/[4rem] lg:text-5xl/[5rem] max-w-6xl px-8 font-semibold sm:font-bold text-center'>
                Achieve Excellence Through Collaboration, Innovation And Teamwork
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className='bg-app-light-gray/10'>
        <div className='app-main-container xl:max-w-[90rem] pt-14 pb-16 md:py-20 space-y-4 sm:space-y-0 flex flex-col md:flex-row justify-between gap-10'>
          <p className='text-xl font-bold text-center sm:pb-4 md:p-4 md:text-2xl xl:text-4xl text-app-orange md:text-left app-animation-translate-right-start'>
            Our Team
          </p>
          <div className='grid grid-cols-1 gap-10 md:grid-cols-2'>
            {teams.map((item, i) => (
              <div key={i} className='flex flex-row gap-8 pl-8 app-animation-scale-start md:p-4'>
                <img src={item.image} alt={item.name} className='object-contain object-center bg-white border rounded-lg aspect-square w-36 sm:w-40 md:w-20 lg:w-32 xl:w-48' />
                <div className='flex flex-col justify-between'>
                  <div>
                    <p className='text-base font-bold md:text-lg xl:text-xl'>{item.name}</p>
                    <p className='text-sm md:text-base xl:text-lg'>{item.position}</p>
                  </div>
                  {item.linked_in_url && item.linked_in_url !== "" && (
                    <div>
                      <a href={item.linked_in_url} target="_blank" rel="noopener noreferrer">
                        <LinkedinIcon className="w-5 h-5 fill-black md:h-6 xl:h-8 md:w-6 xl:w-8" />
                      </a>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  )
}

export default OurTeam